import { actionCreatorFactory } from "typescript-fsa";

const factory = actionCreatorFactory("MODULF");

export const requestUpdateDueWiedervorlagenCount = factory<RequestUpdateDueWiedervorlagenCountPayload>(
	"REQUEST_UPDATE_WIEDERVORLAGEN_COUNT"
);

export const reloadWiedervorlagen = factory<{ activityId: string }>("RELOAD_WIEDERVORLAGEN");

export interface RequestUpdateDueWiedervorlagenCountPayload {
	readonly activityId: string;
}
